import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './UserInfoModal.css';

const UserInfoModal = () => {
    const { showUserInfoModal, setShowUserInfoModal, getUserInfo, logout } = useAuth();
    
    const userInfo = getUserInfo();

    const handleLogout = () => {
        setShowUserInfoModal(false);
        logout();
    };

    if (!showUserInfoModal || !userInfo) return null;

    return (
        <div 
            className="user-info-modal-overlay" 
            onClick={() => setShowUserInfoModal(false)}
        >
            <div 
                className="user-info-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="user-info-header">
                    <h3>User Information</h3>
                    <button 
                        className="close-btn"
                        onClick={() => setShowUserInfoModal(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                
                <div className="user-info-content">
                    <div className="info-item">
                        <span className="info-label">User ID (62):</span>
                        <span className="info-value">{userInfo.userId}</span>
                    </div>
                    
                    <div className="info-item">
                        <span className="info-label">User ID (10):</span>
                        <span className="info-value">{userInfo.sUserId}</span>
                    </div>
                    
                    <div className="info-item">
                        <span className="info-label">Nickname:</span>
                        <span className="info-value">{userInfo.nickname}</span>
                    </div>
                    
                    <div className="info-item">
                        <span className="info-label">VIP Level:</span>
                        <span className="info-value">{userInfo.vipLevel}</span>
                    </div>
                </div>
                
                <div className="user-info-footer">
                    <button 
                        className="logout-btn"
                        onClick={handleLogout}
                    >
                        <i className="fas fa-sign-out-alt"></i>
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserInfoModal;